import { useMemo } from 'react';
import type { Skill } from 'lib/sdks/search';
import { useSelector } from 'react-redux';
import { selectSearch } from 'containers/CompanyContainer/selectors';
import flattenSkills from '@utils/formatters/flatten-skills';

export const useGetInitialCategory = (skills: Skill[], categoryId?: number) => {
  const recentSearch = useSelector(selectSearch);
  const recentSearchCategoryId = recentSearch?.category?.id;

  const initialCategoryId = useMemo(() => {
    if (categoryId) {
      return categoryId;
    }

    const doesTradeCategoryFromLastSearch = Boolean(
      recentSearchCategoryId &&
        skills.length >= 1 &&
        flattenSkills(skills).find(
          skill => skill.id === recentSearchCategoryId,
        ),
    );

    if (doesTradeCategoryFromLastSearch) {
      return recentSearchCategoryId;
    }

    if (skills.length === 1) {
      const firstSkill = skills[0];
      return firstSkill.id;
    }

    if (skills.length === 0) {
      return 6;
    }
  }, [categoryId, recentSearchCategoryId, skills]);

  return initialCategoryId;
};
